<template>
  <div class="app-container jj-card-stats">
    <!-- 搜索栏 -->
    <el-card shadow="never" class="mb18">
      <el-form :inline="true" size="small" class="filter-form" @submit.native.prevent>
        <el-form-item label="企业名称" class="f-item">
          <el-input
            v-model="listQuery.name"
            placeholder="请输入企业名称"
            clearable
            class="f-input"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item label="appid" class="f-item">
          <el-input
            v-model="listQuery.app_id"
            placeholder="请输入 appid"
            clearable
            class="f-input f-input--wide"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item label="统计时间" class="f-item">
          <el-date-picker
            v-model="dateArr"
            type="daterange"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            unlink-panels
            :picker-options="pickerOptions"
            class="f-date"
          />
        </el-form-item>
        <el-form-item class="f-item f-actions">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
            >查询</el-button
          >
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 统计框：今日 / 昨日 / 时间段累计 -->
    <el-row :gutter="12" class="mb18">
      <el-col
        v-for="card in statCards"
        :key="card.key"
        :xs="12"
        :sm="8"
        :md="4"
      >
        <el-card shadow="never" class="box-card">
          <div class="value" :style="{ color: card.color }">
            {{ card.value }}
          </div>
          <div class="subtitle">{{ card.label }}</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 列表 -->
    <el-card shadow="never">
      <el-alert
        v-if="showStatPending"
        type="warning"
        :closable="false"
        show-icon
        title="统计指标待后端接口提供：当前仅展示企业名称与 appid，营业额/间夜数列为空。接口就绪后自动生效。"
        style="margin-bottom: 12px"
      />
      <div class="table-toolbar">
        <span class="tb-left"
          >共 <b>{{ total }}</b> 张锦江卡</span
        >
        <span class="tb-right">统计范围：{{ rangeTxt }}</span>
      </div>
      <el-table
        class="desktop-only"
        v-loading="listLoading"
        :data="pagedList"
        element-loading-text="Loading"
        border
        fit
        highlight-current-row
        size="small"
        :default-sort="{ prop: 'total_sales', order: 'descending' }"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="index"
          label="#"
          width="50"
          align="center"
          :index="indexMethod"
        />
        <el-table-column
          prop="name"
          label="企业名称"
          min-width="200"
          show-overflow-tooltip
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ scope.row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="app_id"
          label="appid"
          min-width="230"
          show-overflow-tooltip
          sortable="custom"
        >
          <template slot-scope="scope">
            <span class="mono">{{ scope.row.app_id || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="today_sales"
          label="今日营业额"
          min-width="110"
          align="right"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ fmtMoney(scope.row.today_sales) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="today_room_nights"
          label="今日间夜数"
          min-width="105"
          align="right"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ fmtNum(scope.row.today_room_nights) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="yesterday_sales"
          label="昨日营业额"
          min-width="110"
          align="right"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ fmtMoney(scope.row.yesterday_sales) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="yesterday_room_nights"
          label="昨日间夜数"
          min-width="105"
          align="right"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ fmtNum(scope.row.yesterday_room_nights) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="total_sales"
          label="总营业额（时间段）"
          min-width="132"
          align="right"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ fmtMoney(scope.row.total_sales) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="total_room_nights"
          label="总间夜数（时间段）"
          min-width="128"
          align="right"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{ fmtNum(scope.row.total_room_nights) }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100"
          align="center"
          fixed="right"
        >
          <!-- 操作列预留：后续按需补充操作按钮 -->
          <template slot-scope="scope">
            <span class="op-placeholder"></span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 移动端卡片视图（≤768px） -->
      <div class="mobile-card-list">
        <div v-if="!pagedList.length" class="mobile-card-empty">
          无匹配锦江卡
        </div>
        <article
          v-for="(card, index) in pagedList"
          :key="card.id"
          class="mobile-card"
        >
          <div class="mobile-card__top">
            <div class="mobile-card__title">
              <span class="mobile-card__rank">{{ indexMethod(index) }}</span>
              <span class="mobile-card__name">{{ card.name || '-' }}</span>
            </div>
          </div>
          <div class="mobile-card__id">{{ card.app_id || '—' }}</div>
          <div class="mobile-card__metrics">
            <div class="mobile-card__metric">
              <div class="mobile-card__label">今日营业额</div>
              <div class="mobile-card__value">
                {{ fmtMoney(card.today_sales) }}
              </div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">今日间夜数</div>
              <div class="mobile-card__value">
                {{ fmtNum(card.today_room_nights) }}
              </div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">昨日营业额</div>
              <div class="mobile-card__value">
                {{ fmtMoney(card.yesterday_sales) }}
              </div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">昨日间夜数</div>
              <div class="mobile-card__value">
                {{ fmtNum(card.yesterday_room_nights) }}
              </div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">总营业额（时间段）</div>
              <div class="mobile-card__value">
                {{ fmtMoney(card.total_sales) }}
              </div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">总间夜数（时间段）</div>
              <div class="mobile-card__value">
                {{ fmtNum(card.total_room_nights) }}
              </div>
            </div>
          </div>
        </article>
      </div>

      <!-- 移动端分页 -->
      <mobile-pager
        :current-page="currentPage"
        :total="total"
        :page-size="pageSize"
        @change="currentPage = $event"
      />

      <!-- 桌面端分页 -->
      <div class="desktop-pagination">
        <span style="font-size: 12px; color: #909399"
          >共 {{ total }} 条 &nbsp; {{ pageSize }}条/页</span
        >
        <el-pagination
          layout="sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          :current-page="currentPage"
          small
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import moment from 'moment'
import MobilePager from '@/components/MobilePager.vue'

const DATE_FMT = 'YYYY-MM-DD'

export default {
  name: 'JinjiangCardStats',
  components: { MobilePager },
  data() {
    const end = new Date()
    const start = new Date()
    start.setDate(start.getDate() - 29) // 默认近30天
    const startTxt = moment(start).format(DATE_FMT)
    const endTxt = moment(end).format(DATE_FMT)

    return {
      listLoading: false,
      rawList: [], // 后端返回的全量锦江卡数据
      listQuery: {
        name: '',
        app_id: '',
        start_at: startTxt + ' 00:00:00',
        end_at: endTxt + ' 23:59:59',
      },
      dateArr: [startTxt, endTxt],
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(p) {
              const d = new Date()
              p.$emit('pick', [d, d])
            },
          },
          {
            text: '近7天',
            onClick(p) {
              const e = new Date()
              const s = new Date()
              s.setTime(s.getTime() - 3600 * 1000 * 24 * 6)
              p.$emit('pick', [s, e])
            },
          },
          {
            text: '近30天',
            onClick(p) {
              const e = new Date()
              const s = new Date()
              s.setTime(s.getTime() - 3600 * 1000 * 24 * 29)
              p.$emit('pick', [s, e])
            },
          },
          {
            text: '本月',
            onClick(p) {
              const e = new Date()
              const s = new Date(e.getFullYear(), e.getMonth(), 1)
              p.$emit('pick', [s, e])
            },
          },
        ],
      },
      sortProp: 'total_sales',
      sortOrder: 'descending',
      currentPage: 1,
      pageSize: 10,
    }
  },
  computed: {
    // 企业名称 / appid 本地过滤（接口不需要支持这两个参数）
    filteredList() {
      const kwName = (this.listQuery.name || '').trim().toLowerCase()
      const kwApp = (this.listQuery.app_id || '').trim().toLowerCase()
      return this.rawList.filter((row) => {
        if (kwName && !String(row.name || '').toLowerCase().includes(kwName)) {
          return false
        }
        if (
          kwApp &&
          !String(row.app_id || '').toLowerCase().includes(kwApp)
        ) {
          return false
        }
        return true
      })
    },
    sortedList() {
      const list = this.filteredList.slice()
      const prop = this.sortProp
      const order = this.sortOrder
      if (!prop || !order) return list
      const dir = order === 'ascending' ? 1 : -1
      // 仅指标列按数值排序；其余（企业名称/appid）按字符串排序
      const numCols = [
        'today_sales',
        'today_room_nights',
        'yesterday_sales',
        'yesterday_room_nights',
        'total_sales',
        'total_room_nights',
      ]
      const isNum = numCols.indexOf(prop) >= 0
      return list.sort((a, b) => {
        if (isNum) {
          const na = parseFloat(a[prop])
          const nb = parseFloat(b[prop])
          const aNil = isNaN(na)
          const bNil = isNaN(nb)
          if (aNil && bNil) return 0
          if (aNil) return 1 // 无值一律排最后
          if (bNil) return -1
          return (na - nb) * dir
        }
        return String(a[prop] || '').localeCompare(String(b[prop] || ''), 'zh') * dir
      })
    },
    pagedList() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.sortedList.slice(start, start + this.pageSize)
    },
    total() {
      return this.filteredList.length
    },
    // 后端尚未提供统计字段时给出提示（接口就绪后自动消失）
    showStatPending() {
      if (this.listLoading || !this.rawList.length) return false
      return !this.rawList.some(
        (r) =>
          r.today_sales !== null ||
          r.total_sales !== null ||
          r.total_room_nights !== null
      )
    },
    // 统计框：对当前筛选结果求和（今日/昨日为固定口径；总营业额/总间夜数随所选时间段）
    statCards() {
      const sum = (key) =>
        this.filteredList.reduce((acc, r) => {
          const v = parseFloat(r[key])
          return acc + (isNaN(v) ? 0 : v)
        }, 0)
      return [
        {
          key: 'today_sales',
          label: '今日营业额',
          value: '¥' + this.money(sum('today_sales')),
          color: '#546dfe',
        },
        {
          key: 'today_room_nights',
          label: '今日间夜数',
          value: this.num(sum('today_room_nights')),
          color: '#546dfe',
        },
        {
          key: 'yesterday_sales',
          label: '昨日营业额',
          value: '¥' + this.money(sum('yesterday_sales')),
          color: '#E6A23C',
        },
        {
          key: 'yesterday_room_nights',
          label: '昨日间夜数',
          value: this.num(sum('yesterday_room_nights')),
          color: '#E6A23C',
        },
        {
          key: 'total_sales',
          label: '总营业额（时间段）',
          value: '¥' + this.money(sum('total_sales')),
          color: '#67C23A',
        },
        {
          key: 'total_room_nights',
          label: '总间夜数（时间段）',
          value: this.num(sum('total_room_nights')),
          color: '#67C23A',
        },
      ]
    },
    rangeTxt() {
      if (!this.listQuery.start_at || !this.listQuery.end_at) {
        return '全部历史'
      }
      return (
        this.listQuery.start_at.slice(0, 10) +
        ' ~ ' +
        this.listQuery.end_at.slice(0, 10)
      )
    },
  },
  watch: {
    dateArr(val) {
      if (val && val[0] && val[1]) {
        this.listQuery.start_at = val[0] + ' 00:00:00'
        this.listQuery.end_at = val[1] + ' 23:59:59'
      } else {
        // 未选时间段 = 历史总统计
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
      this.currentPage = 1
    },
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      // 锦江卡数量少（十余张），一次取全量，前端做过滤/排序/分页/汇总
      request({
        url: '/api/backend/api-account/list',
        method: 'get',
        params: {
          api_type: 'jin_jiang',
          start_at: this.listQuery.start_at || undefined,
          end_at: this.listQuery.end_at || undefined,
          limit: 999,
        },
      })
        .then((response) => {
          const payload = response.data || {}
          const rows = Array.isArray(payload) ? payload : payload.data || []
          this.rawList = rows.map(this.normalizeRow)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 统计字段由后端在返回行内提供；缺失时置 null（页面显示 -）
    normalizeRow(row) {
      const pick = (...keys) => {
        for (const k of keys) {
          const v = row[k]
          if (v !== undefined && v !== null && v !== '') return v
        }
        return null
      }
      return {
        id: row.id,
        name: row.name,
        app_id: row.app_id,
        today_sales: pick('today_sales'),
        today_room_nights: pick('today_room_nights'),
        yesterday_sales: pick('yesterday_sales'),
        yesterday_room_nights: pick('yesterday_room_nights'),
        total_sales: pick('total_sales', 'sales'),
        total_room_nights: pick('total_room_nights'),
      }
    },
    handleFilter() {
      this.currentPage = 1
      this.getList()
    },
    handleReset() {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 29)
      const s = moment(start).format(DATE_FMT)
      const e = moment(end).format(DATE_FMT)
      this.listQuery.name = ''
      this.listQuery.app_id = ''
      this.listQuery.start_at = s + ' 00:00:00'
      this.listQuery.end_at = e + ' 23:59:59'
      this.dateArr = [s, e]
      this.sortProp = 'total_sales'
      this.sortOrder = 'descending'
      this.currentPage = 1
      this.getList()
    },
    handleSortChange({ prop, order }) {
      this.sortProp = prop
      this.sortOrder = order
      this.currentPage = 1
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    fmtMoney(v) {
      if (v === null || v === undefined || v === '') return '-'
      const n = parseFloat(v)
      if (isNaN(n)) return '-'
      return '¥' + this.money(n)
    },
    fmtNum(v) {
      if (v === null || v === undefined || v === '') return '-'
      const n = parseFloat(v)
      if (isNaN(n)) return '-'
      return this.num(n)
    },
    money(n) {
      return n.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    num(n) {
      return n.toLocaleString('en-US')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mb18 {
  margin-bottom: 18px;
}

/* ===== 搜索栏控件宽度 ===== */
.filter-form {
  .f-input {
    width: 180px;
  }

  .f-input--wide {
    width: 200px;
  }

  .f-date {
    width: 260px;
  }
}

/* ===== 列表工具条 ===== */
.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 13px;
  color: #606266;

  .tb-right {
    color: #909399;
    font-size: 12px;
  }
}

/* ===== 统计卡 ===== */
.box-card {
  text-align: center;
  margin-bottom: 12px;

  .value {
    font-weight: bold;
    font-size: 22px;
    line-height: 1.2;
    word-break: break-all;
  }

  .subtitle {
    font-size: 12px;
    color: #909399;
    margin-top: 6px;
  }
}

::v-deep .el-card__body {
  padding: 16px;
}

.mono {
  font-family: Menlo, Consolas, monospace;
  font-size: 12px;
}

/* 操作列预留占位（不显示内容，仅保持单元格） */
.op-placeholder {
  display: inline-block;
  min-height: 1px;
}

/* ===== 桌面端分页 ===== */
.desktop-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
}

/* 移动端卡片视图默认隐藏 */
.mobile-card-list {
  display: none;
}

/* ===== 移动端适配（≤768px） ===== */
@media (max-width: 768px) {
  .desktop-only,
  .desktop-pagination {
    display: none !important;
  }

  .mobile-card-list {
    display: block;
  }

  /* 搜索栏：每项独占一行，控件满宽 */
  .filter-form {
    ::v-deep .el-form-item {
      display: block;
      margin-right: 0;
      margin-bottom: 10px;
    }

    ::v-deep .el-form-item__content {
      display: block;
      margin-left: 0 !important;
      line-height: normal;
    }

    ::v-deep .el-form-item__label {
      float: none;
      display: block;
      padding: 0 0 4px;
      color: #8a94a6;
      font-size: 12px;
      line-height: 20px;
      text-align: left;
    }
  }

  .f-input,
  .f-input--wide,
  .f-date {
    width: 100% !important;
  }

  /* 统计卡：保持两列，数值缩小防溢出 */
  .box-card {
    margin-bottom: 10px;

    .value {
      font-size: 18px;
    }
  }

  /* 工具条换行 */
  .table-toolbar {
    flex-wrap: wrap;

    .tb-right {
      width: 100%;
      margin-top: 4px;
    }
  }

  /* ===== 移动端卡片 ===== */
  .mobile-card {
    margin-bottom: 10px;
    padding: 12px 14px 10px;
    border: 1px solid #eef1f6;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
  }

  .mobile-card__top,
  .mobile-card__title {
    display: flex;
    align-items: center;
  }

  .mobile-card__top {
    justify-content: space-between;
  }

  .mobile-card__title {
    min-width: 0;
  }

  .mobile-card__rank {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin-right: 6px;
    border-radius: 50%;
    background: #f0f2f5;
    color: #909399;
    font-size: 11px;
    font-weight: 600;
  }

  .mobile-card__name {
    max-width: 68vw;
    overflow: hidden;
    color: #1f2733;
    font-size: 15px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mobile-card__id {
    margin: 3px 0 2px 24px;
    color: #8a94a6;
    font-family: Menlo, Consolas, monospace;
    font-size: 11px;
    word-break: break-all;
  }

  .mobile-card__metrics {
    display: flex;
    flex-wrap: wrap;
    margin-top: 4px;
    padding-top: 6px;
    border-top: 1px dashed #eef1f6;
  }

  .mobile-card__metric {
    flex: 0 0 50%;
    box-sizing: border-box;
    padding: 5px 10px 3px 0;
  }

  .mobile-card__label {
    margin-bottom: 1px;
    color: #8a94a6;
    font-size: 11px;
  }

  .mobile-card__value {
    color: #1f2733;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
    word-break: break-all;
  }

  .mobile-card-empty {
    padding: 26px 0;
    color: #909399;
    font-size: 13px;
    text-align: center;
  }
}
</style>
